export default __webpack_public_path__ + "static/media/wolf.1fd85043.png";